import {
	ArrowBack as ArrowBackIcon,
	Groups as GroupsIcon,
	Person as PersonIcon,
	ScheduleOutlined as ScheduleOutlinedIcon,
} from '@mui/icons-material'

import {
	Divider,
	Tooltip,
} from '@mui/material'

import ErrorBoundary from '../ErrorBoundary'

import {
	formatConversationDate,
	formatConversationPreview,
	formatPhoneNumber,
	isScoutAccountActive,
} from '../../services/scout'

import ConversationAvatar from './ConversationAvatar'
import EditableField from '../ui/EditableField'

const ConversationSidebar = ({
	selectedAccount,
	selectedAccountAvatarClassName,
	filteredConversations,
	selectedConversationId,
	selectConversation,
	handleBackNavigation,
	getStableConversationTitle,
	hasMoreConversations,
	onConversationListScroll,
	onSaveConversationTitle,
	isEditableContactConversation,
}) => {
	const selectedAccountActive = selectedAccount ? isScoutAccountActive(selectedAccount) : false

	return (
		<aside className="scout-panel scout-panel--sidebar scout-conversations-sidebar">
			<div style={{ padding: '1rem' }}>
				<button
					type="button"
					className="scout-back-link"
					onClick={handleBackNavigation}
				>
					<ArrowBackIcon />
					<span>Voltar</span>
				</button>

				{selectedAccount ? (
					<div className="scout-account-hero">
						<ConversationAvatar
							conversation={selectedAccount}
							displayName={selectedAccount?.name || 'Conta'}
							className={selectedAccountAvatarClassName}
						/>
						<div className="scout-account-hero__content">
							<strong>{selectedAccount.name}</strong>
							<span>{formatPhoneNumber(selectedAccount.phone_number)}</span>
						</div>
						{!selectedAccountActive ? (
							<Tooltip title="Número desconectado. Você ainda pode visualizar o histórico de conversas.">
								<ScheduleOutlinedIcon className="scout-account-card__status-icon" />
							</Tooltip>
						) : null}
					</div>
				) : null}
			</div>

			<Divider />

			<div className="scout-conversation-list" onScroll={onConversationListScroll}>
				{filteredConversations.map((conversation) => {
					const selected = conversation.id === selectedConversationId

					return (
						<div
							key={conversation.id}
							role="button"
							tabIndex={0}
							className={selected ? 'scout-conversation-row scout-conversation-row--selected' : 'scout-conversation-row'}
							onClick={() => selectConversation(conversation.id)}
							onKeyDown={(e) => {
								if (e.key === 'Enter' || e.key === ' ') {
									e.preventDefault()
									selectConversation(conversation.id)
								}
							}}
						>
							{conversation.type === 'CONTACT' ? <PersonIcon /> : <GroupsIcon />}
							<ConversationAvatar conversation={conversation} displayName={getStableConversationTitle(conversation)} />
							<div className="scout-conversation-row__body">
							<div className="scout-conversation-row__top">
								{isEditableContactConversation(conversation) ? (
									<EditableField
										value={getStableConversationTitle(conversation)}
										placeholder="Clique para adicionar um nome"
										onSave={(value) => onSaveConversationTitle(conversation, value)}
									/>
								) : (
									<strong>{getStableConversationTitle(conversation)}</strong>
								)}
								{conversation.category ? (
									<Tooltip title={`Confiança: ${Math.round(conversation.category.confidence * 100)}%`}>
										<span className="scout-chip scout-conversation-row__category-chip">{conversation.category.name}</span>
									</Tooltip>
								) : null}
								{formatConversationDate(conversation.last_message_timestamp)
									? <small className="scout-conversation-row__date">{formatConversationDate(conversation.last_message_timestamp)}</small>
									: null}
							</div>
							<span>{formatConversationPreview(conversation, {
								connectedPhone: selectedAccount?.phone_number,
								connectedName: selectedAccount?.name,
							})}</span>
						</div>
						</div>
					)
				})}
				{hasMoreConversations && !filteredConversations.length ? (
					<div className="scout-panel__empty scout-panel__empty--thread">Carregando conversas...</div>
				) : null}
			</div>
		</aside>
	)
}

const ConversationSidebarWithBoundary = (props) => (
    <ErrorBoundary
        componentName="ConversationSidebar"
        showReload
        logToBackend
        title="Erro na lista de conversas"
        message="Ocorreu um erro ao exibir a lista de conversas. Tente novamente."
    >
        <ConversationSidebar {...props} />
    </ErrorBoundary>
)

export default ConversationSidebarWithBoundary
